export enum ViewType {
  CARD = 'CARD',
  FORM = 'FORM',
}
